import { useEffect, useRef, useState } from 'react';
import { formatMeetingElapsedTime } from '@/components/session-call/formatMeetingElapsedTime';

const useTranscriptionElapsedTimer = (active: boolean) => {
	const [elapsedLabel, setElapsedLabel] = useState('00:00');
	const startedAtRef = useRef<number | null>(null);

	useEffect(() => {
		if (!active) {
			startedAtRef.current = null;
			setElapsedLabel('00:00');
			return;
		}

		if (startedAtRef.current === null) {
			startedAtRef.current = Date.now();
		}

		const tick = () => {
			if (startedAtRef.current === null) return;
			setElapsedLabel(
				formatMeetingElapsedTime(Date.now() - startedAtRef.current),
			);
		};

		tick();
		const intervalId = window.setInterval(tick, 1000);
		return () => window.clearInterval(intervalId);
	}, [active]);

	return elapsedLabel;
};

export { useTranscriptionElapsedTimer };
